import { render, staticRenderFns } from "./VendorLedger.vue?vue&type=template&id=a5e06f82"
import script from "./VendorLedger.vue?vue&type=script&lang=js"
export * from "./VendorLedger.vue?vue&type=script&lang=js"
import style0 from "./VendorLedger.vue?vue&type=style&index=0&id=a5e06f82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports